export default "__VITE_ASSET__1bd46e52__"